const cocktails = {
  loading: true,
  loadingCocktail: true,
  detailsLoading: true,
  opened: '',
  list: {},
}
const CocktailsReducer = function (state = cocktails, action) {
  switch (action.type) {
    case 'TOGGLE_COCKTAILS_LOADING': {
      return {
        ...state,
        loading: action.value,
      }
    }
    case 'TOGGLE_COCKTAILS_FULL_LOADING': {
      return {
        ...state,
        loadingCocktail: action.value,
      }
    }
    case 'TOGGLE_COCKTAIL_LOADING': {
      return {
        ...state,
        detailsLoading: action.value,
      }
    }
    case 'SELECT_COCKTAIL': {
      return {
        ...state,
        opened: action.cocktail,
      }
    }
    case 'UPDATE_COCKTAILS_LIST': {
      let newList = {}
      Object.entries(action.list).forEach(([key, value]) => (newList[key] = { ...state.list[key], ...value }))
      return {
        ...state,
        list: {
          ...state.list,
          ...newList,
        },
      }
    }
    default: {
      return state
    }
  }
}

export default CocktailsReducer
